import { Injectable, EventEmitter } from '@angular/core';
import { State } from '../shared/state';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * service for communication between components
 */
export class CommunicationService {

  fruLocal: boolean;
  fruLocalKiosk: boolean;
  modalClosed = new EventEmitter<boolean>();
  purchaseStateStep: boolean;
  state: State;
  maxCashoutForm: boolean;
  shouldSetDefaultSelected: Subject<boolean>;
  constructor() {
    this.shouldSetDefaultSelected = new Subject<boolean>();
  }
  getShouldSetDefaultSelected() {
    return this.shouldSetDefaultSelected.asObservable();
  }
  setShouldSetDefaultSelected(enable: boolean) {
    this.shouldSetDefaultSelected.next(enable);
  }


}
